import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { trackEvent } from '../../../lib/analytics';

import { selectIsModalDiagramCreateNewEnabled, selectModalDiagramCreateNewData } from '../../../redux/main/main.selectors';
import { toggleDiagramCreate, toggleDiagramCreateNew, diagramCreate } from '../../../redux/main/main.actions';
import { selectCurrentWorkspace } from '../../../redux/workspace/workspace.selectors';
// import { selectDiagramsList } from '../../../redux/main/main.selectors';
// import { usePlanGate } from '../../../hooks/usePlanGate';


import Modal from '../Modal/Modal';

import './ModalDiagramCreateNew.scss';

const ENGINE_LABEL = {
    mysql: 'MySQL',
    postgresql: 'PostgreSQL',
    sqlserver: 'SQL Server',
    oracle: 'Oracle',
    sqlite: 'SQLite',
    mariadb: 'MariaDB',
};

export const ModalDiagramCreateNew = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalDiagramCreateNewEnabled);
    const modalData = useSelector(selectModalDiagramCreateNewData);
    const currentWorkspace = useSelector(selectCurrentWorkspace);
    // const diagrams = useSelector(selectDiagramsList) || [];
    // const { isAtCap, notifyCap } = usePlanGate();

    const [page, setPage] = useState('');

    const [selectedDb, setSelectedDb] = useState('mysql');

    useEffect(() => {
        if (!modalData?.page) return;
        setPage(modalData?.page);

        return () => { };
    }, [modalData]);


    const handleCancel = () => {
        dispatch(toggleDiagramCreateNew(null));

        setTimeout(() => {
            setSelectedDb('mysql');
        }, 300);
    };

    const handleBack = () => {
        setTimeout(() => {
            dispatch(toggleDiagramCreateNew(null));
            dispatch(toggleDiagramCreate(page));
            setSelectedDb('mysql');
        }, 50);
    };

    const hasWorkspace = !!currentWorkspace?.id;
    const canCreate = hasWorkspace && !!selectedDb;

    const handleCreate = () => {
        trackEvent('app_modal_diagram_new_submit', {
            page: 'app',
            type: 'modals',
            subtype: selectedDb,
        });
        if (!selectedDb) return;
        if (!currentWorkspace?.id) return;

        // // Frontend plan gate: block at the cap before any backend call.
        // if (isAtCap('diagrams', diagrams.length)) {
        //     dispatch(toggleDiagramCreateNew(null));
        //     notifyCap('diagrams', { current: diagrams.length });
        //     return;
        // }

        const title = `New ${ENGINE_LABEL[selectedDb]} Diagram`;

        dispatch(diagramCreate({
            workspaceId: currentWorkspace.id,
            title,
            dbEngine: selectedDb,
            onSuccess: ({ id }) => history.push(`/d/${id}`),
        }));

        dispatch(toggleDiagramCreateNew(null));
        setTimeout(() => {
            setSelectedDb('mysql');
        }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-create-new ${page}`}
            onCancel={handleCancel}
        >
            {/* <div className="modal-content-header">{`Let's build something new`}</div> */}
            <div className="modal-content-body">

                <div className='section-group'>
                    <div className='section-group-item'>
                        <div className='section-group-item-title'>{t('m_new_diagram.title')}</div>

                        {/* <div className="section-group-item-title second">{t('m_new_diagram.subtitle')}</div> */}

                        <div className='left-group right'>
                            <div className='right-group'>
                                <div className={`left-group-item import ${selectedDb === 'mysql' ? 'selected' : ''}`} onClick={() => setSelectedDb('mysql')}>
                                    MySQL
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'postgresql' ? 'selected' : ''}`} onClick={() => setSelectedDb('postgresql')}>
                                    PostgreSQL
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'sqlserver' ? 'selected' : ''}`} onClick={() => setSelectedDb('sqlserver')}>
                                    SQL Server
                                </div>
                            </div>
                            <div className='right-group'>
                                <div className={`left-group-item import ${selectedDb === 'oracle' ? 'selected' : ''}`} onClick={() => setSelectedDb('oracle')}>
                                    Oracle
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'sqlite' ? 'selected' : ''}`} onClick={() => setSelectedDb('sqlite')}>
                                    SQLite
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'mariadb' ? 'selected' : ''}`} onClick={() => setSelectedDb('mariadb')}>
                                    MariaDB
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {!hasWorkspace && (
                    <div className="empty-workspace-hint">
                        {t('m_new_diagram.no_workspace')}
                    </div>
                )}

                {/* <div className="description-text">Enter a new diagram name</div>
                <input
                    autoComplete="off"
                    ref={inputRef}
                    spellCheck="false"
                    type="text"
                    id="board-name"
                    placeholder="Enter diagram name"
                    value={'New Diagram'}
                // onChange={(e) => setName(e.target.value)}
                /> */}


                <div className='buttons-section'>
                    {/* <button className='button-second' onClick={() => handleBack()}>{t('b.back')}</button> */}
                    {/* <button onClick={() => handleCreate()}>{t('m_new_diagram.create_diagram')}</button> */}
                    {/* <button className='button-second' onClick={() => handleBack()}>Back</button> */}
                    <button
                        disabled={!canCreate}
                        onClick={() => handleCreate()}
                    >
                        {t('m_new_diagram.create_diagram')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramCreateNew;
